module.exports = __webpack_public_path__ + "static/media/tournaments-menu-icon.cb0f96ae.svg";